<template>
  <div id="components-layout-demo-basic" style="background: #ececec">
    <a-layout>
      <a-layout-header>课后服务开放平台</a-layout-header>
    </a-layout>
    <div v-if="loading" style="text-align: center;margin-top: 40vh;"><a-spin></a-spin></div>
    <div class="page-border" v-else>
      <div class="group1 content-card">
        <span class="word1" v-if="state.status == 0">等待审核</span>
        <span class="word1" v-else>审核结果</span>
      </div>
      <a-card :bordered="false" class="content-card">
        <div class="header" v-if="state.status == 0">
          <img class="pic1" referrerpolicy="no-referrer" src="/icon/reg/r2.png" />
          <div class="wrap1">
            <span class="word3">已完成资料的提交。</span>
            <span class="word4">请耐心等待后台审核。</span>
          </div>
        </div>
        <div class="header" v-if="state.status == 4">
          <img class="pic1" referrerpolicy="no-referrer" src="/icon/reg/cY.png" />
          <div class="wrap1">
            <span class="word3">初审通过</span>
            <span class="word4">已初审通过，请耐心等待下一步审核。</span>
          </div>
        </div>
        <div class="header" v-if="state.status == 1">
          <img class="pic1" referrerpolicy="no-referrer" src="/icon/reg/cY.png" />
          <div class="wrap1">
            <span class="word3">审核通过</span>
            <span class="word4">已审核通过，可前往教师小程序进行登录。</span>
          </div>
        </div>
        <div class="header" v-if="state.status == 5">
          <img class="pic1" referrerpolicy="no-referrer" src="/icon/reg/cY.png" />
          <div class="wrap1">
            <span class="word3">复审通过</span>
            <span class="word4">已复审通过，请耐心等待下一步审核。</span>
          </div>
        </div>
        <div class="box3"></div>
        <!-- 个人 -->
        <div class="four-one">
          <TeacherInfo ref="teacherInfoRef" :scene="2" :state="state" :isMobile="isMobile"></TeacherInfo>
        </div>
      </a-card>
    </div>
  </div>
</template>
<script>
import bureau from "../../api/bureau";
import school from '../../api/school'
import user from "../../api/user";
import teacher from '../../api/teacher'
import TeacherInfo from "./components/TeacherInfo.vue"
import Vue from "vue";
export default {
  components: {
    TeacherInfo
  },
  data() {
    return {
      state: {
        gender: 1,
        intro: '',
        ...this.$store.state.register.form,
        degreeCertificatList: [],
        auditFailed: true,
      },
      requiredSetting: [],
      isMobile: false,
      loading: true,
    }
  },
  created() {
    if (location.search.match(/webtoken=([\w\.\-_]+)(&|$)/) && location.search.match(/webtoken=([\w\.\-_]+)(&|$)/)[1]) {
      this.$ls.set('token', location.search.match(/webtoken=([\w\.\-_]+)(&|$)/)[1])
    }
    bureau.getBureauId().then((res) => {
      Vue.ls.set('bureauId',res)
      this.initInfo()
    })
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    initInfo() {
      teacher.getMyself().then((res) => {
        Promise.all([
          this.getTeacherRequiredFieldsById(res.data.userId),
          user.init()
        ]).then(() => {
          this.loading = false
          this.state = res.data
          this.$nextTick(() => {
            this.$refs.teacherInfoRef.requiredSetting = this.requiredSetting
          })
          this.$nextTick(() => {
            this.$refs.teacherInfoRef.dataBack(res.data)
          })
        })
      });
    },
    checkMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      // 检测常见移动设备关键词
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|MicroMessenger/i.test(userAgent)
      this.showCopy = this.isMobile
      // 适配窗口小于800px
      this.isMobile = this.isMobile || window.innerWidth <= 800
    },
    // 获取教师必填字段
    getTeacherRequiredFieldsById(id) {
      new Promise((resolve, reject) => { 
        school.getTeacherRequiredFieldsById(id).then((res) => {
          this.requiredSetting = res.data.settingKeyValueDTOS;
          resolve()
        });
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';
@media screen and (min-width: 1280px) {
  div.page-border {
    padding-top: 108px;
    height: 100%;
  }
}

@media screen and (max-width: 1280px) {
  div.page-border {
    padding-top: 28px;
    padding-right: 10px;
    padding-left: 10px;
    height: 100%;
  }
}

div.page-border {
  background: #ececec;
}

.content-card {
  max-width: 1080px;
  min-width: 800px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

#components-layout-demo-basic {
  text-align: left;
  height: 100vh;
  overflow: auto;
}

#components-layout-demo-basic .ant-layout-header {
  background: #0b0b0f;
  color: #ffffff;
  font-size: 24px;
}

.ant-card {
  border-radius: 20px;
}

.group1 {
  height: 40px;
  padding-left: 30px;
}

.word1 {
  font-size: 24px;
  color: rgba(27, 29, 38, 1);
  line-height: 22px;
}

.header {
  margin: 13px 0 0 6px;
}

.pic1 {
  z-index: 23;
  width: 50px;
  height: 50px;
}

.wrap1 {
  display: inline-block;
  height: 50px;
  vertical-align: middle;
  margin-left: 23px;

  .word3 {
    display: block;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
  }

  .word4 {
    color: rgba(135, 136, 138, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    margin-top: 8px;
  }
}

.box3 {
  z-index: 19;
  width: calc(100% - 20px);
  height: 4px;
  background-color: rgba(235, 241, 253, 1);
  align-self: center;
  margin: 37px 10px 40px 10px;
}

@media screen and (max-width: 800px) {
  .content-card {
    min-width: calc(100vw - 20px);
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
